<tec-item
    [classes]="['item--outline']"
    [outline]="true"
    [tagImage]="{ icon: 'icon-resize-viewport', status: 'simple' }"
    [tagIcon]="tagIcon"
    [title]="'PROCESSES.DETAIL.FACIAL_RECOGNITION' | translate"
    [clickeable]="false"
>
    @if (detail?.actions?.FACIAL_RECOGNITION?.details?.similarity) {
        <tec-list-detail>
            <span>{{
                'GENERAL.SIMILARITY' | translate : { similarity: detail?.actions?.FACIAL_RECOGNITION?.details?.similarity }
            }}</span>
        </tec-list-detail>
    }

    <tec-link [label]="'GENERAL.SHOW_DETAILS' | translate" (click)="seeDetails()" />
</tec-item>

@if (showDataComparison) {
    <app-modal-data-comparison
        [ages]="{ low_age: detail?.low_age, high_age: detail?.high_age }"
        [birthdate]="birthdate"
        [polAntifraud]="detail?.antifraud"
        [polImages]="polImages"
        [ocrImages]="ocrImages"
        (closeEvent)="closeModalDataComparison()"
    />
}